export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'platform-intro',
    name: '平台介绍',
    description: '全面了解91com平台的核心功能与特色',
    icon: 'ri-computer-line',
    articleCount: 12,
  },
  {
    slug: 'usage-guide',
    name: '使用教程',
    description: '从入门到精通，快速掌握91com使用方法',
    icon: 'ri-book-open-line',
    articleCount: 18,
  },
  {
    slug: 'account-security',
    name: '账号安全',
    description: '保护您的91com账号，防范各类安全风险',
    icon: 'ri-shield-check-line',
    articleCount: 8,
  },
  {
    slug: 'latest-news',
    name: '最新动态',
    description: '91com平台最新更新、公告与行业资讯',
    icon: 'ri-newspaper-line',
    articleCount: 15,
  },
  {
    slug: 'faq-help',
    name: '常见问题',
    description: '解答您在使用91com过程中遇到的常见疑问',
    icon: 'ri-question-answer-line',
    articleCount: 20,
  },
  {
    slug: 'community',
    name: '社区交流',
    description: '加入91com用户社区，分享经验与技巧',
    icon: 'ri-group-line',
    articleCount: 10,
  },
];